import { createFileRoute } from '@tanstack/react-router'

import { DashboardPage } from '#/modules/dashboard/dashboard-page'
import { OrgScopePage } from '#/modules/org-scope/org-scope-page'
import { HomePage } from '#/pages/home'
import { validateDashboardSearch } from '#/pages/home/lib/dashboard-search'
import type { DashboardSearch } from '#/pages/home/lib/dashboard-search'
import { SegmentedTabs } from '#/shared/ui/segmented-tabs'

type DashboardView = 'platform' | 'home'

interface IndexSearch extends DashboardSearch {
  view?: DashboardView
}

export const Route = createFileRoute('/_shell/')({
  component: CombinedDashboardPage,
  validateSearch: (raw: Record<string, unknown>): IndexSearch => ({
    ...validateDashboardSearch(raw),
    ...(raw['view'] === 'home' ? { view: 'home' as const } : {}),
  }),
})

const VIEWS = [
  { value: 'platform' as const, render: () => 'Platform' },
  { value: 'home' as const, render: () => 'Home' },
]

function CombinedDashboardPage() {
  const { view = 'platform' } = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center">
        <SegmentedTabs
          value={view}
          items={VIEWS}
          onValueChange={(next) =>
            void navigate({
              search: next === 'home' ? { view: 'home' } : {},
              replace: true,
            })
          }
        />
      </div>
      {view === 'platform' ? (
        <DashboardPage />
      ) : (
        <OrgScopePage>
          {(orgId) => (
            <HomePage key={orgId} />
          )}
        </OrgScopePage>
      )}
    </div>
  )
}
